import o from "tonweb";
const {
  utils: { BN: i },
  boc: { Cell: n },
  Address: s
} = o;
function w(t) {
  const e = new n();
  return e.bits.writeUint(260734629, 32), e.bits.writeUint(t.queryId, 64), e.bits.writeCoins(new i(t.amount)), e.bits.writeAddress(new s(t.destination)), e.bits.writeAddress(
    t.responseDestination ? new s(t.responseDestination) : void 0
  ), t.customPayload ? (e.refs.push(t.customPayload), e.bits.writeBit(!0)) : e.bits.writeBit(!1), e.bits.writeCoins(new i(t.forwardTonAmount)), t.forwardPayload ? (e.refs.push(t.forwardPayload), e.bits.writeBit(!0)) : e.bits.writeBit(!1), e;
}
export {
  w as createJettonTransferMessage
};
//# sourceMappingURL=createJettonTransferMessage.js.map
